
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
section {
  background-color: var(--blue-responsible-lighten-5);
  padding: 1.5rem;
}@media (min-width: 1024px) {section {
    max-width: 585px;
  }
}section{
  border-radius:5px;
}

.hr{
  width:100%;
  height:1px;
  margin:0 auto;
  background-color:rgba(0, 37, 54, 0.3);
  margin-top:40px;
  margin-bottom:40px;
}
`;